<template>
  <v-dialog v-model="dialog" width="800">
    <aprobar-suspencion-interinato :movilidad="movilidad" />
  </v-dialog>
</template>

<script>
import AprobarCambioItem from "@/components/admin/persona/components/AprobarCambioItem";
import AprobarMovilidadItem from "../components/AprobarMovilidadItem";
import AprobarSuspencionItem from "../components/AprobarSuspencionItem";
import AprobarSuspencionInterinato from "../components/AprobarSuspencionInterinato";
import AprobarRetiro from "../components/AprobarRetiro";
import AprobarComisionServicio from "../components/AprobarComisionServicio";

export default {
  components: {
    AprobarCambioItem,
    AprobarRetiro,
    AprobarComisionServicio,
    AprobarMovilidadItem,
    AprobarSuspencionItem,
    AprobarSuspencionInterinato
  },
  data() {
    return {
      dialog: false,
      movilidad: {
        funcionario: {}
      }
    };
  },
  mounted() {
    this.$bus.$on("openDialogSuspencionInterinatoMovilidad", item => {
      //console.log('adentroooooooooo')
      this.movilidad = item;
      this.dialog = true;
    });
    this.$bus.$on("closeDialogAprobar", () => {
      this.close();
    });
  },
  methods: {
    close() {
      this.dialog = false;
      this.movilidad = {
        funcionario: {}
      };
      this.$bus.$emit("closeDialogMovilidad");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/dialogs/SuspencionInterinatoMovilidad.vue